import { useEffect } from 'react';
import { useLivePriceStore } from './liveprice.store';
import type { LivePriceSymbolsKeyEnum } from './liveprice.store.types';

export const useLivePriceSender = (
  key: LivePriceSymbolsKeyEnum,
  symbols: string[],
) => {
  const { setLivePriceSymbols } = useLivePriceStore();

  const stringSymbols = symbols.join();

  useEffect(() => {
    const listSymbol = stringSymbols ? stringSymbols.split(',') : [];

    setLivePriceSymbols(key, listSymbol);
    return () => setLivePriceSymbols(key, []);
  }, [key, stringSymbols, setLivePriceSymbols]);
};
